import { Tooltip } from "@mui/material"
import { styled } from "@mui/material/styles"
import React from "react"

/**
 * Styled tooltip for events
 */
export const EventTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderRadius: "8px",
      padding: "12px 16px",
      fontSize: "0.875rem",
      maxWidth: "none",
      whiteSpace: "nowrap",
    },
    [`& .MuiTooltip-arrow`]: {
      color: theme.palette.primary.main,
    },
  })
)

/**
 * Styled tooltip for "more events" link
 */
export const MoreEventsTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: "8px",
    padding: "12px 16px",
    fontSize: "0.875rem",
  },
  [`& .MuiTooltip-arrow`]: {
    color: theme.palette.primary.main,
  },
}))
